import Dictionary from "~/ts/library/Dictionary";
import {virtualOperatorToOperator} from "~/operatorApplication/ts/service/operators/virtualOperatorToOperator";

export function getOperatorByMessage(
    message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel,
    operatorsDictionary: Dictionary<OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel>,
    virtualOperatorsDicitonary?: Dictionary<OperatorApplicationApi.OperatorGetParamsSiteVirtualOperatorOpenApiModel>
): OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel | null {
    if (message.virtualOperatorId && virtualOperatorsDicitonary) {
        let virtualOperator = virtualOperatorsDicitonary[message.virtualOperatorId];
        if (virtualOperator) {
            return virtualOperatorToOperator(virtualOperator);
        }
    }
    return operatorsDictionary[message.operatorLogin];
}